import { AxiosResponse } from 'axios';

import { phpApi } from '../../../api';
import { ApiReject, ApiResolve } from '../../../types/api';
import { UpdatePasswordResponse } from '../passwordUpdatePopup.types';

export const updatePassword: (oldPassword: string, newPassword: string)
=> Promise<UpdatePasswordResponse> = (oldPassword: string, newPassword: string): Promise<UpdatePasswordResponse> => new Promise(
  (resolve: ApiResolve<UpdatePasswordResponse>, reject: ApiReject): Promise<void | never[]> => (
    phpApi.post('/api/user/update-password', { password: oldPassword, newPassword })
      .then((response: AxiosResponse<UpdatePasswordResponse>): void => resolve(response.data))
      .catch((error: AxiosResponse): void => reject(error))
  )
);
